import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ShopItem } from '../../../../models/shop/shop-item.model';
import { ApiShopService } from '../../../../services/shop/api/api-shop.service';
import { ShopService } from '../../../../services/shop/shop.service';
import { AlertsService } from '../../../../services/alerts.service';
import { ModalsService } from '../../../../services/modals.service';
import { ShopItemAddModalComponent } from '../../modals/shop-item-add-modal/shop-item-add-modal.component';
import { ShopItemEditModalComponent } from '../../modals/shop-item-edit-modal/shop-item-edit-modal.component';

@Component({
  selector: 'app-shop-items-tab',
  templateUrl: './shop-items-tab.component.html',
  standalone: true,
  imports: [CommonModule, TooltipModule, ShopItemAddModalComponent, ShopItemEditModalComponent]
})
export class ShopItemsTabComponent implements OnInit {

  @ViewChild('addModal') addModal!: ShopItemAddModalComponent;
  @ViewChild('editModal') editModal!: ShopItemEditModalComponent;

  get items(): ShopItem[] {
    return this.shopService.items;
  }

  get isLoading(): boolean {
    return !this.shopService.isLoaded;
  }

  constructor(
    public shopService: ShopService,
    private apiShopService: ApiShopService,
    private alertsService: AlertsService,
    private modalsService: ModalsService
  ) {}

  ngOnInit(): void {}

  onClickAdd(): void {
    this.addModal.show(() => this.shopService.refresh());
  }

  onClickEdit(item: ShopItem): void {
    this.editModal.show(item, () => this.shopService.refresh());
  }

  onClickDelete(item: ShopItem): void {
    this.modalsService.showConfirmModal(() => {
      this.apiShopService.deleteItem(item.itemId).then(
        () => {
          this.alertsService.displayAlertSuccess('Item deleted !');
          this.shopService.refresh();
        }, error => {
          this.alertsService.displayAlertError('Error deleting item : ' + error);
        }
      );
    });
  }
}
